import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to build a Flutter app?",
    answer: ` <ul><li>Developing a simple Flutter app with basic features usually falls within the range of $50,000 to $60,000.</li>
      <li>The estimated cost for developing a Flutter app with medium complexity falls in the range of $60,000 to $80,000</li>
      <li>The cost of developing a complex app using Flutter may fluctuate depending on features, functionalities, and technology integration, starting at $80,000.</li>
      </ul>`,
  },
  {
    question: "Is Flutter good for mobile app development?",
    answer: `<p>Yes, developers can write and maintain a single codebase for both iOS and Android platforms. This eliminates the necessity for distinct development teams, reducing both development time and effort.</p>`,
  },
  {
    question: "How long does it take to develop a Flutter app?",
    answer: `<p>The duration to develop a Flutter app greatly fluctuates based on its complexity and features.</p> <p>A simple app with basic features can be developed in 1-3 months, while a more complex and feature-rich app may take several months to a year or more for development.</p>`,
  },
  {
    question: "Is Flutter good for app development?",
    answer: `<p>Absolutely! Flutter is a highly flexible technology that accommodates the creation of diverse applications, suitable for startups and enterprises alike.</p> <p>Moreover, it's great for small applications since it allows for fast application development with the low-cost delivery of the final product.</p>`,
  },
  {
    question:
      "Which company was the first to use Flutter to develop a mobile app?",
    answer: `<p>Google Ads was one of the companies to first use Flutter to develop its mobile app, which is a great extension of the desktop version.</p> <p>Google, the creator of Flutter, actively uses the framework for constructing its products. Google Ads mobile strikes a balance between desktop features, effectively meeting the requirements of millions of global users.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Flutter App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
